export const dataSource = [
  'Aiz*** mendapat 70 berlian',
  'Jar*** mendapat 70 berlian',
  'Nai*** mendapat 716 berlian',
  'Sar*** mendapat 70 berlian',
  'Fra*** mendapat 70 berlian',
  'Aul*** mendapat 70 berlian',
  'Xor*** mendapat 70 berlian',
  'Pap*** mendapat 716 berlian',
  'Amm*** mendapat 70 berlian',
  'Ali*** mendapat 716 berlian',
  '788*** mendapat 70 berlian',
  '278*** mendapat 70 berlian',
  '678*** mendapat 716 berlian',
  '708*** mendapat 70 berlian',
  'Der*** mendapat 70 berlian',
  'Ale*** mendapat 70 berlian',
  'Dor*** mendapat 70 berlian',
  '278*** mendapat 716 berlian',
  'Ger*** mendapat 70 berlian',
  '779*** mendapat 716 berlian',
  '448*** mendapat 70 berlian',
  '998*** mendapat 70 berlian',
  'Her*** mendapat 716 berlian',
  'Law*** mendapat 70 berlian',
  '870*** mendapat 70 berlian',
  '675*** mendapat 70 berlian',
  'Lor*** mendapat 70 berlian',
  '232*** mendapat 716 berlian',
  'Lee*** mendapat 70 berlian',
  'Nar*** mendapat 716 berlian',
]
